export default "__VITE_ASSET__DuEWyMjP__"